export const ToothIcon = ({ fill }: { fill?: string }) => (
  <svg
    width="11px"
    height="15px"
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="tooth-icon"
  >
    <path
      d="M8.09669 0.904297C6.39209 0.904297 6.03696 1.68642 5.50427 1.68642C4.93607 1.68642 4.723 0.904297 3.08942 0.904297C1.45584 0.904297 0.283936 1.68642 0.283936 3.80932C0.283936 5.50765 1.34931 8.21653 1.882 9.35867C1.73995 10.985 1.78256 14.2376 3.08942 14.2376C4.723 14.2376 3.94172 9.35867 5.50427 9.35867C7.06682 9.35867 6.7117 14.2376 8.09669 14.2376C9.20468 14.2376 9.31595 10.985 9.23309 9.35867C9.7421 8.14204 10.7601 5.32888 10.7601 3.80932C10.7601 1.90988 9.80129 0.904297 8.09669 0.904297Z"
      fill={fill || '#5F5F5F'}
      fillOpacity="0.94"
    />
  </svg>
);
